import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PredefinedPricingTier, PredefinedPricingTierDto, PredefinedPricingTierValue, PredefinedPricingTiersValueDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getTiers(): Observable<PredefinedPricingTier[]> {
        return this.httpClient
            .get<PredefinedPricingTierDto[]>('predefined-pricing-tiers')
            .pipe(map((response) => response.map((dto) => new PredefinedPricingTier(dto))));
    }

    saveTiers(value: PredefinedPricingTierValue[]): Observable<PredefinedPricingTier[]> {
        const dto = new PredefinedPricingTiersValueDto(value);

        return this.httpClient
            .post<PredefinedPricingTierDto[]>('predefined-pricing-tiers', dto)
            .pipe(map((response) => response.map((item) => new PredefinedPricingTier(item))));
    }
}
